// Text / Labels
export const PAGINATION_TEXT = {
  ROWS_PER_PAGE: "Rows per page:",
  NO_MESSAGES: "No data available",
  SHOWING: "Showing",
  TO: "to",
  OF: "of",
  MESSAGES: "messages",
};

// Config values
export const PAGINATION_CONFIG = {
  MAX_VISIBLE_PAGES: 5,
  ROWS_PER_PAGE_OPTIONS: [25, 50, 100],
  PREV_SYMBOL: "<",
  NEXT_SYMBOL: ">",
  ELLIPSIS: "...",
};
